export const cifJm = ["301 151","<defs><path id='a' d='M.5.5h300v150H.5z'/></defs><g fill='none' fill-rule='evenodd'><path fill='#009B3A' fill-rule='nonzero' d='M.5.5h300v150H.5z'/><mask id='b' fill='#fff'><use xlink:href='#a'/></mask><path d='M300.5.5l-150 75 150 75M.5.5l150 75-150 75' stroke='#FED100' stroke-width='20' fill='#000' fill-rule='nonzero' mask='url(#b)'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-jm.js
// module id = null
// module chunks = 